module.exports = __webpack_public_path__ + "img/delete_icon_white.4ff79fdb.svg";